<template>
  <v-btn
    v-bind="$attrs"
    :disabled="disabled || processing"
    :loading="loading && processing"
    @click="handleClick"
  >
    <slot />
  </v-btn>
</template>

<script>
export default {
  name: 'VButtonProcessing',
  inheritAttrs: false,
  props: {
    // A function which returns Promise.
    onclick: {
      type: Function,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      processing: false,
    };
  },
  methods: {
    handleClick(event) {
      if (this.processing) return;
      this.processing = true;
      this.onclick(event)
        .finally(() => {
          this.processing = false;
        });
    },
  },
};
</script>
